

import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';
import LoadingProcessing from "../common/LoadingProcessing";



class WalletTopupComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user:null,
            List: [],
            SelectedDealer:null,
            modeTopup:false,
            Wallets:[],
            transferAmount:"",
            isLoading:false
        }

    }

    async componentDidMount() {
        await this.isSupperUser();
        await this.fetchWallet();
        await this.fetchDealer();
    }

    isSupperUser = async () => {
        let user = GetUserToken();
        const role = user.Role;
        if (role !== "super") {
            alert("Sorry you can't perform this action,Your role is: " + role + "");
            window.location.href = "#/home"
        }
        this.setState({
            user:user
        })
    }

    fetchWallet = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("wallet", conds, (data) => {
            console.log("fetchWallet :> ", data);
            _this.setState({
                Wallets: data,
            });
        });
    }
    fetchDealer= async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("Dealership", conds, (data) => {
            console.log("fetchDealer :> ", data);
            _this.setState({
                List: data,
            });
        });
    }
    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }

    submitTopup=async ()=>{
        let _this = this;
        _this.setState({
            isLoading:true
        });
        let hub={
            SenderRef: "0871112223",
            RecipientRef : this.state.SelectedDealer.ref,
            TransAmount : parseFloat(this.state.transferAmount),
        }

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/wallet-topup/add";

        console.log("submitTopup send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn) {
            console.log("submitTopup response > ", dataIn);
            alert("Thank you,ToUp success!");
            _this.setState({
                modeTopup:false,
                SelectedDealer:null,
                transferAmount:"",
                isLoading:false
            });

            _this.fetchWallet();
            _this.fetchDealer();

        });

    }

    cancelTransfer=()=>this.setState({
        modeTopup:false,
        SelectedDealer:null,
        transferAmount:""
    });

    renderDealerWalletList=()=>{

        if(this.state.modeTopup){
            return null
        }

        const _this = this;
        const getWallet = (ref) => {
            let myWallet = {};
            for (let i in _this.state.Wallets) {
                const row = _this.state.Wallets[i];
                if (row.accountref === ref) {
                    myWallet = row;
                }
            }
            return myWallet
        }

        return(
            <table className={"table"}>
                <thead>
                <tr>
                    <th>Phone</th>
                    <th>Name</th>
                    <th>Balance</th>
                    <th>#</th>
                </tr>
                </thead>
                <tbody>
                {this.state.List.map((row,index)=>{
                    const o = getWallet(row.ref);
                    return(
                        <tr key={index}>
                            <td>{row.ref}</td>
                            <td>{row.name}</td>
                            <td>{o.amount}</td>
                            <td>
                                <a
                                    className={"btn btn-primary"}
                                    onClick={()=>this.setState({
                                        SelectedDealer:row,
                                        modeTopup:true,
                                })}>Top Up</a>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        )

        /*
        contactaddress: "01 peddie road, milnerton,cape town, 7441"
​​
contactperson: "Merveilleux Biangacila"
​​
contactphone: "0729139504"
​​
date: "2019-03-30"
​​
dealerstatus: "active"
​​
email: "biangacila@gmail.com"
​​
id: "a77ef6e4-82b5-448a-bcff-3162244fe068"
​​
name: "Dikamba"
​​
orgdatetime: "2019-03-30 13:24:38"
​​
phone: "0729139504"
​​
profile: null
​​
ref: "0729139504"
​​
status: "active"
​​
time: "13:24:38"
         */
    }

    handleTransAmount=(e)=>{
        this.setState({
            transferAmount: e.target.value
        })
    }

    renderTransfer=()=>{
        if(!this.state.modeTopup){
            return null
        }

        return(
            <div className={"container"}>
                <p className={"alert alert-info"}>Top-Up Wallet
                    <a onClick={()=>this.cancelTransfer()} className={"btn btn-dander pull-right"}>Cancel</a>
                </p>
                <p><b>From : <span style={{color:"red"}}>{this.state.ref+" ("+this.state.user.Fullname+")"}</span></b></p>
                <p><b>To : <span style={{color:"red"}}>{this.state.SelectedDealer.ref+" ("+this.state.SelectedDealer.name+")"}</span></b></p>
                <p>
                    <input
                        onChange={(e)=>this.handleTransAmount(e)}
                        value={this.state.transferAmount}
                        placeholder={"Transfer amount ..."}
                    />
                    <a onClick={()=>this.submitTopup()}
                       className={"btn btn-primary pull-right"}>Submit</a>
                </p>
            </div>
        )
    }

    render() {

        return (


            <PageContentWallpaper {...this.props} >

                {!this.state.modeTransfer&&(
                    <div>
                        <div className="row container">
                            <div className="col-xs-12">
                                <h2>Dealer Wallet List</h2>
                            </div>
                            {this.renderDealerWalletList()}
                        </div>
                    </div>
                )}


                <div>
                    {this.renderTransfer()}
                </div>

                <LoadingProcessing open={this.state.isLoading}/>


            </PageContentWallpaper>
        )


    }


}


const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WalletTopupComponent)